import { useEffect, useCallback } from "react";
import { useClickEventStack } from "canopy-styleguide!sofe";
import { useNav } from "../../nav.context";

const userGuiding = window.userGuiding;

export const useResourceCenter = () => {
  const nav = useNav();

  const onDocClick = useCallback(() => {
    const resourceCenterElement =
      document.getElementsByClassName("RC_PREVIEW")[0];
    if (resourceCenterElement) {
      resourceCenterElement.style["left"] = null;
    }
    userGuiding?.collapseResourceCenter();
  }, []);

  useClickEventStack(onDocClick);

  const mutationCallback = useCallback((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.target.offsetLeft < 0) {
        mutation.target.style["left"] = "80px";
        mutation.target.style["bottom"] = "auto";
      } else {
        mutation.target.style["left"] = null;
      }
    });
  }, []);

  useEffect(() => {
    // give time for userguiding to embed the iframe
    let retryCount = 0;
    let mutationObserver;
    const interval = setInterval(() => {
      const resourceCenterElement =
        document.getElementsByClassName("RC_PREVIEW")[0];
      if (resourceCenterElement) {
        clearInterval(interval);
        mutationObserver = new MutationObserver(mutationCallback);
        mutationObserver.observe(resourceCenterElement, { attributes: true });
      } else {
        retryCount++;
        if (retryCount > 3) {
          clearInterval(interval);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
      mutationObserver?.disconnect();
    };
  }, []);

  const openResourceCenter = (e) => {
    e.stopPropagation();

    userGuiding?.expandResourceCenter();

    if (nav.secondaryOpen) {
      nav.setSecondaryOpen(null);
    }
  };

  return { openResourceCenter };
};
